import { useState } from "react";
import { t } from "@/utils";
import { Flex, Text } from "@/ui";
import Slider from "@/components/Slider";
import Popover from "@/components/Popover";
import IconButton from "@/components/IconButton";
import ConfigureIcon from "assets/icons/configure.svg?react";

type Props = {
  noiseCorrection: NonNullable<CSTypes.CameraSettingsStepProps["noiseCorrection"]>;
};

export default function NoiseCorrection({ noiseCorrection }: Props) {
  const [value, setValue] = useState(noiseCorrection.get());

  function handleChangeEnd(value: number) {
    setValue(value);
    noiseCorrection.set(value);
  }

  return (
    <Popover
      popoverProps={{ gutter: 4, isLazy: true, lazyBehavior: "unmount" }}
      contentProps={{ bg: "surface3", py: "12", px: "24" }}
      body={
        <Flex direction="column" align="center" w="228px">
          <Text variant="title">{t("buttons.adjustSensitivity")}</Text>
          <Slider
            value={value}
            min={-1}
            max={1}
            step={0.02}
            props={{ defaultValue: noiseCorrection.get(), mt: "12", mb: "16" }}
            onChange={(value) => setValue(value)}
            onChangeEnd={(value) => handleChangeEnd(value)}
            thumbProps={{ bg: "primary" }}
            filledTrackProps={{ bg: "primary" }}
          />

          <Flex w="100%">
            <Text
              textAlign="left"
              flexBasis="33%"
              variant="label"
              as="button"
              color="on-surface-variant"
              onClick={() => handleChangeEnd(-1)}
            >
              {t("noiseSensitivity.level.low")}
            </Text>
            <Text
              flexBasis="33%"
              variant="label"
              as="button"
              color="on-surface-variant"
              onClick={() => handleChangeEnd(0)}
            >
              0
            </Text>
            <Text
              textAlign="right"
              flexBasis="33%"
              variant="label"
              as="button"
              color="on-surface-variant"
              onClick={() => handleChangeEnd(1)}
            >
              {t("noiseSensitivity.level.high")}
            </Text>
          </Flex>
        </Flex>
      }
    >
      <IconButton props={{ pos: "absolute", top: "6", right: "6" }} icon={ConfigureIcon} fill="on-surface-variant" />
    </Popover>
  );
}
